import { actions as notificationActions } from '@saucelabs/sl-container-notifications';

import * as api from './api';
import * as actions from './actions';
import { jobsQuerySelector } from './selectors';
import {
  operations as filterOperations,
  actions as filtersActions,
} from './../filters';

import { operations } from './';

export const jobs = () => (dispatch, getState) => {
  dispatch(actions.jobsRequest());
  const params = jobsQuerySelector(getState());
  return api.jobs(params)
    .then(({ data }) => (
      dispatch(actions.jobsSuccess(data))
    )).catch((error) => (
      Promise.all([
        dispatch(actions.jobsFailure(error, { skipErrorPage: true })),
        dispatch(notificationActions.notifyDanger(
          'We\'ve experienced an issue while loading archives.',
        )),
      ])
    ));
};

export const changePage = (payload) => async (dispatch) => {
  await dispatch(filtersActions.changePage(payload));
  return Promise.all([
    dispatch(filterOperations.updateURLWithQuery()),
    dispatch(operations.jobs()),
  ]);
};

export const updateFilter = (payload) => async (dispatch) => {
  dispatch(filterOperations.updateFilter(payload)).then(() => (
    dispatch(operations.jobs())
  ));
};

export const initialize = () => async (dispatch) => {
  await dispatch(filterOperations.initialize());
  return Promise.all([
    dispatch(actions.initialized()),
    dispatch(operations.jobs()),
  ]);
};
